<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [
			{ value: 'airwallex', label: 'Airwallex' },
			{ value: 'wire', label: 'Wire' },
			{ value: 'payoneer', label: 'Payoneer' },
			{ value: 'paypal', label: 'Paypal' },
			{ value: 'wechat', label: 'Wechat(¥)' },
			{ value: 'alipay', label: 'Alipay(¥)' },
			{ value: 'ach', label: 'ACH' },
			{ value: 'usdt', label: 'USDT' },
		];
		return{
			options,
		}
	},
	props:['value'],
}
</script>

